<template>
  <div class="topChangeButton" ref="ChangeButton">
    <div class="center">
      <div class="li"
           :style="{width:`${width}px`,marginLeft:`${marginLeft}px`,height:'100%'}">
        <li :class="{'curr':now==ind}"
            @click="changeBut(ind,item)"
            v-for="(item,ind) in content"
            :key="ind">
          <a href="javascript:;">{{item.detailName}}</a>
        </li>
      </div>
      <div class='arrow-left' v-show="width>scrollWidth"
           @click="changeLeftFn"></div>
      <div class='arrow-right' v-show="width>scrollWidth"
           @click="changeRightFn"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'jinriShow',
  props: {
    content: {
      type: Array
    },
    change: Number
  },
  data () {
    return {
      now: '0',
      width: 0,
      speed: 0,
      marginLeft: 0,
      scrollWidth:0
    }
  },
  mounted () {
    this.computed();
    this.scrollWidth = this.$refs.ChangeButton.clientWidth;
  },
  watch: {
    change: function (val) {
      val ? this.now = val : ''
    },
    content: function (val) {
      this.computed();
    }
  },
  methods: {
    //计算button宽度
    computed () {
      var twid = 0;
      this.content.forEach(element => {
        if (element) {
          twid += ((element.detailName.length * 14) + 40)
        }
      });
      this.width = twid + 10;
      
    },
    //改变按钮
    changeBut (ind, sign) {
      this.now = ind;
      this.$emit('changeBut', ind, sign);
    },
    // 向左平移
    changeLeftFn () {
      if (this.width > this.scrollWidth) {
        if (this.speed == 0) {
          return false;
        }
        this.speed++;
        this.marginLeft = this.speed * 100;
      }
    },
    // 向右平移
    changeRightFn () {
      if (this.width > this.scrollWidth) {
        if (this.width + this.marginLeft < this.scrollWidth) {
          return false;
        }
        this.speed--;
        this.marginLeft = this.speed * 100;
      }
    }
  }
}
</script>
<style scoped>
.topChangeButton {
  display: flex;
  width: 100%;
}
.center {
  width: 100%;
  overflow: hidden;
  position: relative;
}
.arrow-left {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  left: 0;
  background: url("~@/assets/image/images/tab_left_arrow.png") no-repeat center;
  cursor: pointer;
}
.arrow-right {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  right: 0;
  background: url("~@/assets/image/images/tab_right_arrow.png") no-repeat center;
  cursor: pointer;
}
.titles li {
  float: left;
}
.titles li a {
  display: block;
  padding: 0 20px;
  font-size: 14px;
  color: #333;
}
.titles li.curr a {
  background: #0c78cf;
  color: #fff;
}
@media screen   and (max-width: 768px) {
  .topChangeButton {
    width: 90%;
  }
}
</style>>



// WEBPACK FOOTER //
// src/components/floorBlock/topChangeButton.vue